import React from 'react';
import {useNavigate, useLocation, useParams} from 'react-router-dom';
import {DashboardLayout} from 'components';
import {GoBack} from '../../components/GoBack';
import {baasMobile} from 'assets/images/images';
import {useQuery} from 'react-query';
import {fetchBAASSingleCustomer} from 'requests/queries/baas';

function CustomersWrapper({children}) {
  const navigate = useNavigate();
  const location = useLocation();
  const {slug} = useParams();

  const getButtonClass = path =>
    location.pathname.includes(path)
      ? 'border-b-2 border-dojahBlue text-dojahBlue'
      : 'text-[#84858D]';

  const {data, isLoading} = useQuery(
    ['baas-customer', slug],
    () => fetchBAASSingleCustomer({params: {id: slug}}),
    {
      meta: {preventGlobalError: true},
      enabled: !!slug,
      staleTime: 5 * 60 * 1000,
      cacheTime: 10 * 60 * 1000,
    },
  );

  const initials = data?.entity
    ? `${data.entity.first_name?.charAt(0)}${data.entity.last_name?.charAt(0)}`
    : '-';

  return (
    <DashboardLayout
      bg="bg-white"
      topPadding="pt-8"
      xlLeftMargin="xl:ml-12"
      breadCrumbs={
        <div className="flex items-center">
          <img src={baasMobile} alt="" />
          <p className="ml-2 -mb-1">Customers</p>
        </div>
      }
    >
      <GoBack goBack={() => navigate('/baas-customers')} />
      <div className="mt-8 flex items-center gap-3">
        {isLoading ? (
          <div className="animate-pulse flex items-center gap-3">
            <div className="h-[63px] w-[63px] rounded-full bg-[#e5e7eb]"></div>
            <div className="flex flex-col gap-2">
              <div className="h-8 w-40 bg-[#e5e7eb] rounded animate-pulse"></div>
              <div className="h-4 w-32 bg-[#e5e7eb] rounded animate-pulse"></div>
              <div className="h-5 w-24 bg-[#e5e7eb] rounded animate-pulse"></div>
            </div>
          </div>
        ) : (
          <>
            <div className="min-h-[63px] flex items-center justify-center min-w-[63px] rounded-full bg-[#D9E5F8]">
              <h3 className="text-[32px] font-medium text-dojahBlue">
                {initials}
              </h3>
            </div>
            <div className="flex flex-col gap-1">
              <h4 className="text-grey font-medium text-[20px]">
                {data?.entity?.first_name} {data?.entity?.last_name}
              </h4>
              <p className="text-sm font-medium text-[#868C98]">
                {data?.entity?.email}
              </p>
              <span className="rounded-full w-fit px-[8px] py-[4px] bg-[#F3FCF1]">
                <h5 className="font-medium text-[10px] text-[#3FB12C]">
                  {data?.entity?.phone_number}
                </h5>
              </span>
            </div>
          </>
        )}
      </div>
      <div className="w-full border border-transparent border-b-[#ceced2] flex items-center gap-4 mt-11">
        <button
          onClick={() => navigate(`/baas-customers/transactions/${slug}`)}
          className={`outline-none text-sm py-2 font-medium ${getButtonClass(
            'transactions',
          )}`}
        >
          Transactions
        </button>
        <button
          onClick={() => navigate(`/baas-customers/wallets/${slug}`)}
          className={`outline-none text-sm py-2 font-medium ${getButtonClass(
            'wallets',
          )}`}
        >
          Wallets
        </button>
        <button
          onClick={() => navigate(`/baas-customers/cards/${slug}`)}
          className={`outline-none text-sm py-2 font-medium ${getButtonClass(
            'cards',
          )}`}
        >
          Cards
        </button>
      </div>
      {children}
    </DashboardLayout>
  );
}

export default CustomersWrapper;
